import React from 'react'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'

import { Typography, Stack, Divider } from '@mui/material'
import Grid from '@mui/material/Grid'

import { formatDateToFEFormat } from 'utils/date'

import HHDisplayMoney from 'components/common/HHDisplayMoney'
import PaymentStatusChip from 'components/common/chip/PaymentStatusChip'
import { TOTAL_COLUMN_WIDTH, AMOUNT_APPLIED_COLUMN_WIDTH } from './settings'

const PaymentHistoryActivity = ({ historyEntry, align = 'center', marginY = 0 }) => {
  const { transactionPostedDate, transactionStatus, transactionAmountCents, runningTotalCents, paymentNote } = historyEntry
  const capitalizedStatus = capitalize(transactionStatus)
  const transformDate = date => (date ? formatDateToFEFormat(date) : '-')

  return (
    <Grid container spacing={2.5} wrap="nowrap" alignItems={align} size={12}>
      <Grid minWidth={100} my={marginY} size="auto">
        <Typography variant="body2">
          {transformDate(transactionPostedDate)}
        </Typography>
      </Grid>
      <Grid my={marginY} size="grow">
        <Stack spacing={0.5} alignItems="flex-start">
          <PaymentStatusChip status={capitalizedStatus} />
          {paymentNote && (
            <Typography variant="caption" color="text.secondary">
              {paymentNote}
            </Typography>
          )}
        </Stack>
      </Grid>
      <Grid width={TOTAL_COLUMN_WIDTH} my={marginY}>
        <Typography display="flex" alignItems="center" justifyContent="flex-end" variant="h6" fontWeight={500} color="textPrimary">
          <HHDisplayMoney value={runningTotalCents != null ? runningTotalCents : transactionAmountCents} />
        </Typography>
      </Grid>
      <Grid display="flex" size="auto">
        <Divider flexItem orientation="vertical" />
      </Grid>
      <Grid width={AMOUNT_APPLIED_COLUMN_WIDTH} my={marginY}>
        <Typography display="flex" alignItems="center" justifyContent="flex-end" variant="h6" fontWeight={500} color="textPrimary">
          <HHDisplayMoney value={transactionAmountCents} />
        </Typography>
      </Grid>
    </Grid>
  )
}

PaymentHistoryActivity.propTypes = {
  historyEntry: PropTypes.object.isRequired,
  align: PropTypes.string,
  marginY: PropTypes.number,
}

export default PaymentHistoryActivity